import { useState } from "react";

import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import ErrorPlaceholder from "common/components/ErrorPlaceholder";
import Loader from "common/components/Loader";
import RenderIf from "common/components/RenderIf";
import SearchInput from "common/components/SearchInput";
import { Button } from "common/components/ui/Button";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useMembers from "common/datahooks/useMembers";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import DesktopTable from "./DesktopLayout/DesktopTable";
import MobileList from "./MobileLayout/MobileList";

import ResultNotFoundImage from "assets/images/empty-placeholders/result-not-found.png";

export default function Members() {
  const isDesktop = useTwBreakpoint("lg");
  const { max_members: maxMembers } = useSelectedWorkspaceContext();

  const [searchTerm, setSearchTerm] = useState("");

  const { members, isLoadingMembers, isMembersError, refetchMembers } =
    useMembers();

  if (isMembersError)
    return (
      <ErrorPlaceholder
        errorMessage="Could not display members"
        onRetry={refetchMembers}
      />
    );
  if (isLoadingMembers) return <Loader />;

  const lowerCaseSearchTerm = searchTerm.toLowerCase();

  const filteredMembers = members.filter(
    ({ first_name: firstName, last_name: lastName, email }) => {
      const isMatchingFirstName = firstName
        ?.toLowerCase()
        .includes(lowerCaseSearchTerm);

      const isMatchingLastName = lastName
        ?.toLowerCase()
        .includes(lowerCaseSearchTerm);

      const isMatchingEmail = email
        ?.toLowerCase()
        .includes(lowerCaseSearchTerm);

      return searchTerm
        ? isMatchingFirstName || isMatchingLastName || isMatchingEmail
        : true;
    },
  );

  const Component = isDesktop ? DesktopTable : MobileList;

  return (
    <>
      {/* Heading */}
      <div className="flex w-full items-center justify-between gap-3 flex-row">
        <SearchInput
          placeholder="Search members"
          value={searchTerm}
          className="lg:max-w-80"
          variant={isDesktop ? "sm" : "lg"}
          onChange={(e) => setSearchTerm(e.target.value)}
          onClear={() => setSearchTerm("")}
        />

        <RenderIf condition={!!maxMembers}>
          <span className="text-button-md text-black-400 text-nowrap">
            {members.length}/{maxMembers} teammates
          </span>
        </RenderIf>
      </div>

      {filteredMembers.length ? (
        <Component members={filteredMembers} />
      ) : (
        <EmptyPlaceholder
          title="No members Found"
          subtitle="No members match your search criteria. Try adjusting your search"
          imageSrc={ResultNotFoundImage}
          actionComponent={
            <Button onClick={() => setSearchTerm("")}>Clear search</Button>
          }
        />
      )}
    </>
  );
}
